export * from './src/data.view.nav.bar';